<template>
  <div class="relation-info-box clearfix">
    <develop-tree />
    <relation-info-item />
  </div>
</template>
<script>
import DevelopTree from './DevelopTree'
import RelationInfoItem from './RelationInfoItem'
import { mapActions } from 'vuex'
export default {
  components: {
    DevelopTree,
    RelationInfoItem
  },
  data () {
    return {}
  },
  async mounted () {
    const chain2 = await this.fetchRelationDevpDatas()
    chain2.params({ pk: 'inquiry-dev', deal: 1 })
      .fetch()
    const chain3 = await this.fetchRelationOrigionDatas()
    chain3.fetch()
  },
  methods: {
    ...mapActions('config/relation', ['fetchRelationDevpDatas', 'fetchRelationOrigionDatas'])
  }
}
</script>
<style lang="scss" scoped>
.relation-info-box{ width: 100% }
</style>
